var map = {
	"./american-football.svg": "8f5f",
	"./aussie-rules.1.svg": "c758",
	"./aussie-rules.svg": "2125",
	"./badminton.svg": "bbd6",
	"./baseball.svg": "4cd5",
	"./basketball.svg": "b134",
	"./boxing.svg": "94bb",
	"./cricket.svg": "20bc",
	"./darts.svg": "6c4d",
	"./football.svg": "ab74",
	"./handball.svg": "2bb8",
	"./horse-racing.svg": "5a21",
	"./motorsport.svg": "a0da",
	"./rugby.svg": "2f63",
	"./rugbyleague.svg": "b236",
	"./rugbyunion.svg": "bad1",
	"./snooker.svg": "d312",
	"./soccer.svg": "eb27",
	"./tennis.svg": "ee76",
	"./tennisdoubles.svg": "1f7b",
	"./testcricket.svg": "80c6",
	"./volleyball.svg": "be18"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";